
import ChangesLocale from '@/Mixins/ChangesLocale'

export default {
  mixins: [
    ChangesLocale,
  ],

  computed: {
    fallbackLocale () {
      return this.$page.props.brand === 'SBL' ? 'es' : 'en'
    },
  },

  created () {
    this.changeLocale(localStorage.getItem('locale'))
    // ||
    // this.changeLocale(this.$page.props.auth.locale)
    ||
    this.changeLocale(this.fallbackLocale)
  },
}
